import React, { useState } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import ElssStatementReport from "./ElssStatementReport";
import FundHoldingReport from "./FundHoldingReport";
import CapitalGainReport from "./CapitalGainReport";
import TransactionHistoryReport from "./TransactionHistoryReport";

export default function MFReports(props) {
  const [activeTab, setActiveTab] = useState("elss");

  const renderActiveTab = () => {
    switch (activeTab) {
      case "elss":
        return <ElssStatementReport />;
      case "capital":
        return <CapitalGainReport />;
      case "holding":
        return <FundHoldingReport />;
      case "transaction":
        return <TransactionHistoryReport />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header title={props.title} portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="mutualfunds ">
        <div className="tab-content card-box" id="mainTabContent">
          <div>
            <h2>Mutual Fund Reports</h2>
          </div>

          <div className="secondary-tabs">
            <div className="card-tab-list">
              <ul className="nav page-tabs" id="mainTab" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "elss" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("elss")}
                  >
                    ELSS Statement
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "capital" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("capital")}
                  >
                    Capital Gain
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "holding" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("holding")}
                  >
                    Fund Holding
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "transaction" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("transaction")}
                  >
                    Transaction History
                  </button>
                </li>
              </ul>
            </div>

            <div className="card-tab-details">
              <div className="tab-content dashboard-tab-content">
                <div className="tab-pane fade show active">
                  {renderActiveTab()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
